import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentage',
})
export class PercentagePipe implements PipeTransform {
  transform(value: unknown, round = true): string {
    if ((`${value}`.includes('.') || value === 1) && round !== false) {
      value = (value as number) * 10;
    }
    return `${value}%`;
  }
}
